<template>
  <div id="app"
       :class="theme"
       onselectstart="return false;">
    <navleft :selected.sync="selected"
             :items="items" />
    <mainright :selected.sync="selected"
               :items="items"
               :resize="resize"
               :theme="theme"
               :resizeType="blocks[resizeIndex]"
               class="main" />
  </div>
</template>

<script>
import mainright from '../components/main';
import navleft from '../components/nav';
export default {
  name: 'App',
  components: {
    mainright,
    navleft
  },
  created() {
    API.use({
      method: 'Util.getSkinName',
      success: theme => {
        if (theme === '白色风格') {
          this.theme = 'white';
          document.body.setAttribute('theme-mode', 'white');
        }
      }
    });
    // API.use({
    //   method: 'quote.initMarket',
    //   data: 120
    // });
    API.use({
      method:"external.registerEvent",
      data:"onshow",
      persistent:true,
      callbackName:"onshow",
      success:function(data) {
        if (data == 1) {
          TA.log({ id: 'cgpz_pageview', _sid: 'cgpz_pageview' });
        }
      }
    });
    setTimeout(() => {
      window.requestIdleCallback(() => {
        TA.log({ id: 'cgpz_pageview', _sid: 'cgpz_pageview' });
      });
    }, 2000);
  },
  mounted() {
    window.onresize = () => {
      this.resize = document.body.clientWidth;
      this.resizeIndex = 0;
    };

    // window.onresize = () => {
    //   if (Date.now() - this.prevT < 1000) return;
    //   this.resize = document.body.clientWidth;
    //   this.prevT = Date.now();
    // };
  },
  data() {
    return {
      selected: ['lgt', 'sctj'],
      items: {
        lgt: [
          {
            title: '市场统计',
            value: 'sctj',
            type: 'lgt',
            tips: [
              '从所属市场分类统计陆股通资金的持股市值。',
              '上海主板，金融、资源等周期性行业占比较大。',
              '深圳主板，行业分布较为均衡。',
              '创业板，以信息技术为首的新兴产业占比较大。',
              '从持仓的变化，可以看出陆股通资金股票配置的变化。'
            ]
          },
          {
            title: '指数统计',
            value: 'zstj',
            type: 'lgt',
            tips: [
              '从所属指数分类统计陆股通资金的持股市值。',
              '该统计重在分析陆股通对大小盘股的持仓偏好和变化。',
              '中证100代表一线蓝筹，成分股中位数总市值1400亿。',
              '中证200代表二线蓝筹，成分股中位数总市值约400亿。',
              '中证500代表三线成长，成分股中位数总市值约150亿。',
              '中证1000代表四线小盘，成分股中位数总市值约80亿。',
              '其他代表非上述成分股的股票，中位数总市值约40亿元。'
            ]
          },
          {
            title: '行业统计',
            value: 'hytj',
            type: 'lgt',
            tips: [
              '从所属行业分类统计陆股通资金的持股市值。',
              '该统计重在分析陆股通的行业持仓偏好和变化。',
              '行业选自同花顺行业，一级行业24个，二级行业66个。'
            ]
          },
          {
            title: '重仓股统计',
            value: 'zcgtj',
            type: 'lgt',
            tips: ['从重仓个股角度分析陆股通的持股市值。', '仅展示陆股通持股市值占整体超过1%的个股。']
          }
        ],
        ggt: [
          {
            title: '地区统计',
            value: 'sctj',
            type: 'ggt',
            tips: ['从公司所属地区分类统计港股通资金的累计流入和持股市值。', '地区按照公司收入或资产划分为内地、港澳台、国外。']
          },
          {
            title: '指数统计',
            value: 'zstj',
            type: 'ggt',
            tips: [
              '从所属指数分类统计港股通资金的累计流入和持股市值。',
              '该统计重在分析港股通对大小盘股的持仓偏好和变化。',
              'HSLI代表一线蓝筹，成分股中位数总市值1400亿港币。',
              'HSMI代表二线蓝筹，成分股中位数总市值300多亿。',
              'HSHKS代表三线成长，成分股中位数总市值约100亿。'
            ]
          },
          {
            title: '行业统计',
            value: 'hytj',
            type: 'ggt',
            tips: [
              '从所属行业分类统计港股通资金的累计流入和持股市值。',
              '该统计重在分析港股通的行业持仓偏好和变化。',
              '行业选自恒生行业分类，一级行业11个，二级行业31个。'
            ]
          },
          {
            title: '重仓股统计',
            value: 'zcgtj',
            type: 'ggt',
            tips: ['从重仓个股角度分析港股通的累计流入和持股市值。', '仅展示港股通买入额或持股市值占整体超过1%的个股。']
          }
        ]
      },
      resizeIndex: 1,
      blocks: ['market1', 'index1', 'industry1', 'stock1', 'market2', 'index2', 'industry2', 'stock2'],
      resize: document.body.clientWidth,
      loading: false,
      theme: 'black'
      // prevT: Date.now()
    };
  },
  methods: {
    resizeRender() {
      if (this.loading) return;
      if (this.blocks.length < this.resizeIndex) {
        this.loading = false;
        return;
      }
      this.loading = true;

      setTimeout(() => {
        this.resizeIndex++;
        this.loading = false;
        this.resizeRender();
      }, 500);
    }
  },
  watch: {
    resizeIndex(val, old) {
      this.resizeRender();
    }
  }
};
</script>

<style>
@import "../assets/css/index.css";
#app {
  display: flex;
  height: 100%;
}
.nav {
  height: 100%;
}
.main {
  flex-grow: 1; /* default 0 */
  overflow: auto;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}

.btn {
  cursor: pointer;
}
.reverse-arrow {
  transform: rotate(0.5turn);
}
.green {
  color: #08a365;
}
.red {
  color: #e74741;
}

.t-head {
  font-size: 12px;
  text-align: right;
}

.hq_table_base {
  z-index: 1;
}
.hq_table_theadfixed {
  z-index: 2;
}
.hqicon {
  background: url(//s.thsi.cn/js/jsmodule/client/hqtable/icon.jpg) no-repeat;
  width: 10px;
  height: 10px;
  display: inline-block;
  margin-left: 2px;
  font-size: 0;
  _zoom: 1;
  _display: inline;
}
.hqicon-sort-down {
  background-position: 0 -14px;
}
.hqicon-sort-up {
  background-position: -9px -14px;
}

.hq_table {
  border-collapse: collapse;
  line-height: 26px;

  position: relative;
}
.wrap .hq_thead {
  background: #27282c;
  color: #c0c0c0;
}
.hq_thead div {
  font-weight: 500;
  /* padding-right: 10px; */
  /* text-align: center; */
}
.hq_tr_subshow .hq_tr {
  background: #0b1016;
}
.black .hq_tr:hover .hq_td {
  background: #373e48;
}
.hq_tr_subset {
  background: #14171b;
}
.hq_tr_subset:hover {
  background: #373e48;
}

.hq_table_wrap div {
  text-align: right;
  cursor: default;
}
.hq_table .hq_tr .hq_td {
  border: 1px solid #22262b;
  border-top: 0;
  border-left: 0;
  border-right: 0;
}
.hq_tr_subset {
  border: 1px solid #22262b;
  border-top: 0;
  border-left: 0;
  border-right: 0;
}
#app .no-border-bottom {
  border-bottom: 0;
}
.th_sort {
  cursor: pointer;
}
.td_events {
  cursor: pointer !important;
  text-align: left !important;
}
.td_events:hover {
  color: #088ec6;
}
.td-word {
  text-align: left !important;
  cursor: pointer !important;
}
.td-word:hover {
  color: #088ec6;
}
.td-head {
  text-align: left;
}
.td-industry {
  /* padding-left: 8px; */
  text-align: left;
}
.icon-sub {
  display: inline-block;
  width: 12px;
  text-align: center;
}
div[td-key='index'],
div[td-key='55'] {
  color: #fdf084;
}

/* .main::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #000000;
} */

.main::-webkit-scrollbar {
  width: 12px;
  height: 10px;
  background-color: #000000;
}

.main::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}
.main::-webkit-scrollbar-corner {
  background-color: #000000;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-color: #000000;
}

.hq_container_base::-webkit-scrollbar {
  width: 6px;
  background-color: #000000;
}

.hq_container_base::-webkit-scrollbar-thumb {
  border-radius: 5px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}
.hq_container_base::-webkit-scrollbar-corner {
  background-color: #000000;
}
.td_name {
  width: 9.70414201183432%;
}
.td_code {
  width: 7.928994082840236%;
}
.td_hold_amount .td_industry_name {
  width: 7.100591715976331%;
}
.td_industry_name {
  text-align: left;
  /* padding-left: 10px; */
}
.td_accumulated_net_inflow .td_share_market_capital {
  width: 13.964497041420119%;
}
.td_accumulated_profit_loss {
  width: 13.017751479289942%;
}
.td_week_net_inflow {
  width: 12.189349112426036%;
}
.td_week_share_market_capital {
  width: 14.082840236686389%;
}
.td_week_price_change_ratio {
  width: 8.04733727810651%;
}
.ta-left {
  text-align: left;
}
.ta-left:hover {
  color: #088ec6;
}
.margin-left-20 {
  margin-left: 20px;
}

/* theme */
.black .nav,
.black .main,
.black .hq_table,
.black .wrap .hq_thead,
.black .hq_tr_subshow .hq_tr,
.black .content-block {
  background-color: #0b1016;
}
.black .nav,
.black .main,
.black .item-content {
  background-color: #0b1016;
}
.black .nav {
  border-right: 1px solid #22262b;
}
.black .content,
.black .item-a,
.black .item-content,
.black .hq_table {
  color: #ccc;
}
.black .nav-item .item-header {
  border-left: 3px solid #0b1016;
  color: #fff;
}
.black .nav-item .selected {
  border-left: 3px solid #b40606;
  background-color: #31373c;
}
.black .hq_table {
  /* border: 1px solid #22262b; */
  border: 0;
}
.black .hq_table .hq_th {
  border-top: 1px solid #22262b;
  border-bottom: 1px solid #22262b;
}
.black .item-a,
.black .item-header {
  color: #bbbbbb;
}
.black .cal-show {
  background-color: #2e2e2e;
}
/* .black .hq_tr_active {
  background: #213c5a !important;
} */
.black .hq_tr_active .hq_td {
  background: #213c5a !important;
}
.black .hq_tr_active .hq_td:last-child {
 border-right: 1px solid #22262b;
}
.black .block-title {
  background-color: #31373c;
}
.black .content-block {
  border: solid 1px #22262b;
}
.black .t-head {
  background-color: #191e24;
  color: #808081;
}
.black .chart-title {
  color: #ffffff;
  border-left: 2px solid #b40606;
}
.black .fold-btn {
  color: #b3b3b3;
}
.black .chart-title .tips {
  color: #ccc;
}
.black .others .hq_tr div {
  border-bottom: 1px solid #22262b;
}
.black .lgt-tip {
  color: white;
}

.white .hq_table,
.white .wrap .hq_thead,
.white .hq_tr_subshow .hq_tr,
.white .content-block,
.white .hq_container_base::-webkit-scrollbar-corner,
.white .hq_container_base::-webkit-scrollbar,
.white .hq_container_base::-webkit-scrollbar-track,
.white .main::-webkit-scrollbar-corner,
.white .main::-webkit-scrollbar,
.white .main::-webkit-scrollbar-track {
  background-color: #fff;
}
.white .nav,
.white .main,
.white .item-content {
  background-color: #f4f4f4;
}
.white .nav,
.white .item-content {
  border-right: 1px solid #d3cfd0;
}
.white .content,
.white .item-a,
.white .item-header,
.white .item-content,
.white .hq_table,
.white .fold-btn {
  color: #000;
}
.white .hq_table {
  /* border: 1px solid #f4f4f4; */
  border: 0;
}
.white .hq_table .hq_th {
  border-top:  1px solid #f4f4f4;
  border-bottom:  1px solid #000000;
}
.white .hq_table .hq_th:last-child{
  border-right: 1px solid #f4f4f4;
}
.white .nav-item .item-header {
  border-left: 3px solid #d3cfd0;
  color: #000;
}
.white .nav-item .selected {
  border-left: 3px solid #000000;
  background-color: #d3cfd0;
}
.white .cal-show {
  background-color: #d3cfd0;
}
/* .white .hq_tr_active {
   background: #c5d6ec !important;
} */
.white .hq_tr_active .hq_td {
  background: #c5d6ec !important;
}

.white .block-title {
  background-color: #d3cfd0;
}
.white .content-block {
  border: 1px solid #d3cfd0;
}
.white .t-head {
  background-color: #f4f4f4;
  color: #666666;
}
.white .hqicon-sort-down {
  background-position: 0px -1px;
}
.white .hqicon-sort-up {
  background-position: -9px -1px;
}
.white  .hq_tr:hover .hq_td {
  background: #ccc;
}
.white .chart-title {
  color: #000000;
  border-left: 2px solid #000000;
}
.white .hq_tr_subset {
  background: #eff7ff;
}
.white .title-tips {
  color: #ffffff;
}
.white .hq_container_base::-webkit-scrollbar-thumb,
.white .main::-webkit-scrollbar-thumb {
  background: #8f8f8f;
}
.white .chart-title .tips {
  color: #000000;
}
.white .others .hq_tr div {
  border-bottom: 1px solid #f4f4f4;
}
.white .lgt-tip {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/pages/App.vue